import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { GlobalUtilsService } from 'src/app/global-utils.service';
import { environment } from '../../../environments/environment';
import { FormControlName } from './contact-form-types';
import { ContactFormService } from './contact-form.service';

const estados = [
  { label: 'RN', value: 'RN' },
  { label: 'PB', value: 'PB' },
  { label: 'CE', value: 'CE' }
];

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
})
export class ContactFormComponent {
  FormControlName = FormControlName;
  messageControlIsFocused: boolean;
  isSendingMessage: boolean;
  wasSent: boolean;
  estados = estados;

  // mediaConsumoMask = { mask: Number, normalizeZeros: false };
  mediaConsumoMask = {
    lazy: false,
    mask: 'money {(kWh)}',
    blocks: {
      money: {
        mask: Number,
        normalizeZeros: false,
      },
    },
  };

  precoKWHMask = {
    lazy: false,
    mask: '{R$} money',
    blocks: {
      money: {
        mask: Number,
        normalizeZeros: false,
      },
    },
  };

  constructor(
    public contactFormService: ContactFormService,
    public globalUtilsService: GlobalUtilsService,
    private httpClient: HttpClient
  ) {}

  messageActivationController(isFocused: boolean) {
    this.messageControlIsFocused = isFocused;
  }

  sendMessage() {
    if (this.contactFormService.form.valid) {
      this.isSendingMessage = true;
      this.contactFormService.form.disable();

      this.isSendingMessage = true;


      this.httpClient
        .post(environment.func, this.contactFormService.form.value)
        .subscribe({
          next: (res) => {
            this.wasSent = true;
            setTimeout(() => {
              this.wasSent = false;
            }, 3500);
            this.contactFormService.form.reset();
            this.contactFormService.form.enable();

            alert('Mensagem enviada com sucesso');

            this.isSendingMessage = false;
          },
          error: (err) => {
            console.error(err);
            alert(
              'Algum erro ocorreu. Tente novamente em alguns instantes ou envie um email para paraisofotovoltaico@gmail.com'
            );
            // this.contactFormService.form.reset();
            this.contactFormService.form.enable();
            this.isSendingMessage = false;
          },
        });
    } else {
      alert('Preencha todos os campos necessários');
      this.contactFormService.form.markAllAsTouched();
    }
  }
}
